import React, {Component} from 'react';
import {
    Route,
    NavLink,
    Link,
    Switch
} from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Projects from './Projects'
import Courses from './Course'
import './index.css'
import Share from './Share'
import DriveOAuth from './DriveOAuth'
import Button from "../components/Button";
import { loadStripe } from '@stripe/stripe-js';
import {functions} from '../firebaseconfig'


const stripePromise = loadStripe('pk_live_51HLJs1CrDQwhuCBO4LLT7yN5D7gatFthjRk9rV96gTNxOd5Y70XsBwGhkZQYSuA8gYg4q5NycuRTt8YOe4jloM4Z00NKkDdWRW');
const teststripe = loadStripe('pk_test_51HLJs1CrDQwhuCBOPKwSsCxHAplOq396ngiwm9BYqwsUShiWYaIuA3CYrUAnkmAhr7lflWY4z6LOT5GH1zwXXMsd00MLLsBJhJ\n')

export default class StudentApp extends React.Component {
    render() {
        console.log(this.props)
        const menuText = ['Dashboard', 'Projects', 'Course Resources']
        const menuIcon = [
            <i className="fas fa-home"/>,
            <i className="fas fa-code"/>,
            <i className="fas fa-book-open"/>
        ]
        return (
            <div>
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="#">
                            <img src="https://storage.googleapis.com/parallebs.com/img/purplefavico.svg" width="30"/>
                        </a>
                    </div>
                </nav>
                <div style={{marginTop: '20px'}}>
                        <Route exact path="/students" render={() => <Dashboard {...this.props}/>}/>
                        <Route path="/students/projects" render={() => <Projects {...this.props}/>}/>
                        <Route path="/students/courses" render={() => <Courses {...this.props}/>}/>
                        <Route path="/students/share" render={() => <Share {...this.props}/>}/>
                        <Route path="/students/driveoauth" render={() => <DriveOAuth {...this.props}/>}/>
                    <Route exact path="/students/courseregsuccess" render={() => <Success {...this.props}/>}/>
                </div>
            </div>
        )
    }
}

class Success extends React.Component {
    render() {
        return(
            <div className="container text-center">
                <h1>Payment Success</h1>
                <div style={{fontSize: '16px'}}>Thank you for registering for our course.</div>
                <div style={{fontSize: '16px'}}>More instructions on the course will be sent to <strong>{this.props.userInfo.email}</strong> three days before the course.</div>
                <div style={{fontSize: '16px'}}>We look forward to work with you soon!</div>
            </div>
        )
    }
}

class Dashboard extends React.Component {

    state = {
        paymentloading: false,
    }

    checkout = async (id) => {
        // Get Stripe.js instance
        const stripe = await stripePromise;
        const self = this
        const coursecheckout = functions.httpsCallable('coursecheckout');
        self.setState({paymentloading: true})
        coursecheckout().then(function(result) {
            const session = result.data
            console.log(result.data)
            const payment = stripe.redirectToCheckout({
                sessionId: session.id,
            });
            self.setState({paymentloading: false})
            if (payment.error) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer
                // using `result.error.message`.
            }
        });
    };

    getaccess = () => {
        let self = this
        const driveaccess = functions.httpsCallable('uploadnotebooktodrive');
        driveaccess({'course': 'test'}).then(function(result) {
            const session = result.data
            console.log(result.data)
            window.open(result.data)
        });
    }

    render() {
        const courses = [
            {
                name: "Fundamentals in developing simulation models with Python",
                language: ["Python"],
                img: "url('https://storage.googleapis.com/parallebs-students.appspot.com/images/python_thumbnail%20(1).png')",
                registered: false,
                stripeID: "price_1HbpLhCrDQwhuCBOcfhoPsYi",
                time: "31st October 2020, Saturday, 9am",
                price: "SGD 20"
            }
        ]
        const ntucourses = [
            {
                name: "Predict HDB prices in 1 day",
                language: ["Python"],
                img: "https://www.gov.sg/~/media/gov/factually/thumbnail/housing/hdb%20mockup.jpg"
            },
        ]
        return (
            <div className='container'>
                <h1>Projects to help you learn Python</h1>
                <div className="row">
                    {courses.map(each =>
                        <div className='col-6 col-sm-6 col-md-4 col-lg-3' style={{color: '#42175a', margin: '10px 0'}}>
                            {each.registered
                                ?
                                <Paper>
                                    <Link to={`/students/courses/${each.stripeID}`}>
                                        <div className='paper-padding'>
                                            <div style={{
                                                margin: '15px 0',
                                                height: '150px',
                                                backgroundImage: each.img,
                                                backgroundSize: 'cover',
                                                backgroundPosition: '50% 50%'
                                            }}/>
                                            <h3>{each.language.map(lang => `${lang} `)}</h3>
                                            <h2>{each.name}</h2>
                                        </div>
                                    </Link>
                                </Paper>
                                :
                                <Paper>
                                    <div className='paper-padding'>
                                        <div style={{
                                            margin: '15px 0',
                                            height: '150px',
                                            backgroundImage: each.img,
                                            backgroundSize: 'cover',
                                            backgroundPosition: '50% 50%'
                                        }}/>
                                        <div>{each.language.map(lang => `${lang} `)}</div>
                                        <h4>{each.name}</h4>
                                        <div>{each.time}</div>
                                        <h3>{each.price}</h3>
                                        <div style={{marginTop: '20px'}}>
                                            <Button buttonText="Upload Notebook to Google Drive" bgcolor={"#42175a"} onClick={this.getaccess}/>
                                        </div>
                                    </div>
                                </Paper>
                            }
                        </div>
                    )}
                </div>
                <h1>Upcoming courses</h1>
                <div className="row">
                    {courses.map(each =>
                        <div className='col-6 col-sm-6 col-md-4 col-lg-3' style={{color: '#42175a', margin: '10px 0'}}>
                            {each.registered
                                ?
                                <Paper>
                                    <Link to={`/students/courses/${each.stripeID}`}>
                                    <div className='paper-padding'>
                                        <div style={{
                                            margin: '15px 0',
                                            height: '150px',
                                            backgroundImage: each.img,
                                            backgroundSize: 'cover',
                                            backgroundPosition: '50% 50%'
                                        }}/>
                                        <h3>{each.language.map(lang => `${lang} `)}</h3>
                                        <h2>{each.name}</h2>
                                    </div>
                                    </Link>
                                </Paper>
                                :
                                <Paper>
                                    <div className='paper-padding'>
                                        <div style={{
                                            margin: '15px 0',
                                            height: '150px',
                                            backgroundImage: each.img,
                                            backgroundSize: 'cover',
                                            backgroundPosition: '50% 50%'
                                        }}/>
                                        <div>{each.language.map(lang => `${lang} `)}</div>
                                        <h4>{each.name}</h4>
                                        <div>{each.time}</div>
                                        <h3>{each.price}</h3>
                                                <div style={{marginTop: '20px'}}>
                                                    <Button buttonText={this.state.paymentloading ? "Loading payment page .." :  "Register for course"} onClick={this.checkout}
                                                            bgcolor={"#42175a"}/>
                                                </div>
                                    </div>
                                </Paper>
                            }
                        </div>
                    )}
                </div>
                <h1 style={{marginTop: '20px'}}>NTU-CAO exclusive courses</h1>
                <div className="row">
                    {ntucourses.map(each =>
                        <div className='col-6 col-sm-6 col-md-4 col-lg-3' style={{color: '#42175a', margin: '10px 0'}}>
                            <Paper>
                                <Link to={'/students/courses/PythonHDB/content'}>
                                <div className='paper-padding'>
                                    <div style={{
                                        margin: '15px 0',
                                        height: '150px',
                                        backgroundImage: `url(${each.img})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: '50% 50%'
                                    }}/>
                                    <h5>{each.language.map(lang => `${lang} `)}</h5>
                                    <h3>{each.name}</h3>
                                </div>
                                </Link>
                            </Paper>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}






// WEBPACK FOOTER //
// ./src/StudentApp/main.js